import axios from 'axios';

const katswiriInstance = axios.create({
  baseURL: 'https://katswiri.staticcomputersinc.com',
  timeout: 30000,
});

export default katswiriInstance;